export enum ServiceStatusEnum {
    ONBOARDING = 1,
    MONITORED = 2,
    OFFBOARDING = 3,
}

export enum ServiceStatusColorsEnum {
    ONBOARDING = '',
    MONITORED = 'rgba(38, 142, 108, 0.7)',
    OFFBOARDING = '#ffa438',
}
